<template>
    <section id="home-content">
        <div class="container">
            <div class="content mb-4">
                <p class="fw-semibold sub_content">JORNAY PM demonstrated statistically
                    significant symptom control vs placebo in two Phase 3, randomized, double-blind,
                    placebo-controlled studies that enrolled children aged 6 to 12 years.<sup>1-3</sup></p>

            </div>
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange"></span>
                <h2 class="gtitle fw-semibold omnes">
                    Deliver a full day of focus and ADHD symptom control with JORNAY PM<sup class="omnes">1,2</sup></h2>
            </div>

            <div class="content card_container">
                <div class="card_content text-center">
                    <img src="../../assets/img/home/icon-1.png" alt="Orange icon of the moon and sun" />
                    <p> <span class="blue-text font-weight-bold">Demonstrated efficacy</span> upon
                        awakening, through the afternoon, and into the late afternoon/evening. No short-acting booster
                        was permitted in
                        the
                        pivotal trials<sup>2,3</sup></p>
                    <div class="buttons">
                        <a href="/adhd-medication-efficacy" class="button">Discover clinical data</a>
                    </div>
                </div>
                <div class="card_content text-center">
                    <img src="../../assets/img/home/icon-2.png" alt="Orange icon of the colon" />
                    <p>Slowly absorbed in the colon,
                        <span class="text-nowrap">JORNAY PM</span> provides <span
                            class="blue-text font-weight-bold">smooth
                            onset and offset</span> of effect<sup>4,5</sup>
                    </p>
                    <div class="buttons">
                        <a href="/pk-data" class="button">See PK profile</a>
                    </div>
                </div>
                <div class="card_content text-center">
                    <img src="../../assets/img/home/icon-3.png" alt="Orange icon of a clock" />
                    <p>PK/PD data modeled for <span class="blue-text font-weight-bold">dose-dependent duration of
                            effect</span><sup>6*</sup></p>
                    <div class="buttons">
                        <a href="/methylphenidate-dosage-duration" class="button">See PK/PD model</a>
                    </div>
                </div>
                <div class="card_content text-center">
                    <img src="../../assets/img/home/icon-4.png" alt="Orange icon of a dollar sign" />
                    <p>Broad commercial and Medicaid coverage.<sup>7,8</sup> <span class="text-nowrap"> JORNAY PM</span> offers a <span class="blue-text font-weight-bold">savings program</span> for eligible, commercially insured patients</p>
                    <div class="buttons">
                        <a href="/savings" class="button">Find out about savings</a>
                    </div>
                </div>
            </div>

        </div>
        <div class="content py-5 middle-title p-0">
            <div class="container">
                <div class="middle-title_content">
                    <h2 class="gtitle text-center fw-bold">Before prescribing JORNAY PM to your patients, assess
                        each
                        patient’s risk for abuse, misuse, and
                        addiction. Educate patients and caregivers on these risks.</h2>
                </div>
            </div>
        </div>

        <div class="container">



            <div class="content">
                <div class="container content_references mt-5">
                    <ul class="m-0">
                        <li>The PK/PD model was developed utilizing PK data from a phase 1 PK study, and PD data from a
                            phase 3
                            study of JORNAY PM in which SKAMP results were the primary endpoint.<sup>6</sup></li>
                    </ul>
                    <span>PD=pharmacodynamic; PK=pharmacokinetic; SKAMP=Swanson, Kotkin, Agler,
                        M-Flynn, and Pelham.</span>
                </div>
            </div>
        </div>
    </section>
</template>



<script>


export default {
    components: {
    },
    data() {
        return {
        }
    }


}
</script>